import { Component, OnInit } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { BaseComponentConfig, BreadCrumbData, ComponentConfig,ConfigOptions, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { FORMS } from '../forms';
import { SETTINGS as settings } from '../model';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';

@Component({
  selector: 'ubs-survey',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent extends BaseComponentConfig implements OnInit {
  breadCrumbs:BreadCrumbData[];
  options:ConfigOptions = {
    name:"Name",
    title:"Survey",
    addForm:new OfbizForm({
      formName:"EditSurvey",
      entityName:"Survey",
      formLocation:"component://content/widget/survey/SurveyForms.xml"
    }),
    findForm:new OfbizForm({
      local:true,
      formAction:"find",
      viewMode:"popover",
      formName:"FindSurvey",
      entityName:"Survey",
      formLocation:"component://content/widget/survey/SurveyForms.xml",
      target:"listFindSurvey",
      fields:this.getFields("FindSurvey",FORMS),
    }),
    listForm:new OfbizList({
      fieldFormName:"FindSurvey",
      fieldFormLocation:"component://content/widget/survey/SurveyForms.xml",
      fieldFormFields:this.getFields("FindSurvey",FORMS),
      listFormName:"ListFindSurvey",
      listFormLocation:"component://content/widget/survey/SurveyForms.xml",
      entityName:"Survey",
      columnFields:this.getFields("ListFindSurvey",FORMS),
      endPoint:"listFindSurvey",
      emptyListMessage:"",
      viewIndex:1,
      findParameters:[
        {"noConditionFind":"Y"}
      ],
      actions:{
        position:'right',
        custom:[
          {
            name:'overView',
            title:'<i class="nb-eye-outline" title="Over View"></i>'
          }
        ],
        delete:false,
      },
    }),
    actions:["list","find","add","edit"],
    breadCrumbData:{
      displayPrefix:"Surveys",
      label:"",
      level:1,
      selectedValue:{
          "event":"list",
          "type":"ListFindSurvey",
          "data":{
            "formData":{
              "formName":"ListFindSurvey",
              "formLocation":"component://content/widget/survey/SurveyForms.xml",
              "noConditionFind":"Y"
            },
            "endPoint":"listFindSurvey",
          },
      },
      addFormText:"Create New Survey",
      editFormText:"Update Survey",
    },
    settings:settings,
  }

  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(this.options);
  }

  ngOnInit(): void {
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
  }

}
